<template>
    <van-popup v-model="show" mode="center" :class="classObj">
        <div class="content">
            <div class="header">
                <div>{{ $t('weeklySalary.upBonusTitle') }}</div>
                <div v-if="item.type == 'week'">({{ $t('weeklySalary.recordTabWeekly') }})</div>
                <div v-else>({{ $t('weeklySalary.sectionTitle') }})</div>
                <div class="close">
                    <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                </div>
            </div>
            <div class="main_content">
                <div class="desc_txt">
                    {{ $t('weeklySalary.upBonusDesc1') }}
                    <span class="plain">{{ formatCurrency(item.amount, 2) }}</span>,
                    {{ $t('weeklySalary.upBonusDesc2') }}
                    <span class="plain">{{ formatCurrency(item.upgradeBonusLevelUpRechargeAmt, 2) }}</span>,
                    {{ $t('weeklySalary.upBonusDesc3') }}
                    <span class="highlight">{{ formatCurrency(item.levelUpAmount, 2) }}</span>!
                </div>
                <div class="reward_compare">
                    <div class="super_card">
                        <div>
                            <div class="card_label">{{ $t('weeklySalary.upBonusSuperDouble') }}</div>
                            <img class="coin" src="@/assets/vip/icon_BounsCoin.webp" />
                            <div class="super_amount">{{ formatAmount(item.levelUpAmount, 2) }}</div>
                        </div>
                        <img src="@/assets/vip/bg_upBouns.webp" />
                    </div>
                    <div class="claim-center">
                        <div class="multiple_mark">
                            <img src="@/assets/vip/icon_BounsArrow.webp" />
                            <div>x{{ Number(item.amount) > 0 ? Number(item.levelUpAmount) / Number(item.amount) : 0 }}</div>
                        </div>
                    </div>
                    <div class="normal_card">
                        <div class="card_label">{{ $t('weeklySalary.upBonusCommon') }}</div>
                        <img class="coin" src="@/assets/vip/icon_BounsCoin.webp" />
                        <div class="normal_amount">{{ formatAmount(item.amount, 2) }}</div>
                    </div>
                </div>
                <div class="btn_group">
                    <div class="primary" @click.stop="toDeposit">{{ $t('weeklySalary.claim') }} {{
                        formatAmount(item.levelUpAmount, 2) }}</div>
                    <div class="secondary" @click.stop="onReceive">{{ $t('weeklySalary.claim') }} {{
                        formatAmount(item.amount, 2) }}</div>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            isFirstReload: true,
            show: false,
            item: {},
            isCanReceive: true
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        }
    },
    methods: {
        open(item) {
            this.item = item
            this.show = true
        },
        close() {
            this.show = false
        },
        toDeposit() {
            const params = { type: 'deposit', depositType: this.item.depositType, rewardRecordId: this.item.rewardRecordId, upRechargeAmt: this.item.upgradeBonusLevelUpRechargeAmt }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        onReceive() {
            this.$emit('getNormalReward', this.item)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.van-popup {
    background: transparent;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    &.mobile {
        .content {
            .main_content {
                padding: .24rem 0;
                padding-bottom: 0;
            }

            .super_card {
                .coin {
                    width: 110px;
                    height: 110px;
                }
            }

            .normal_card {
                .coin {
                    width: 68px;
                    height: 68px;
                }
            }
            .claim-center{
                margin-left: .08rem;
                margin-right: .1rem;
                .multiple_mark {
                    &>img {
                        width: 58px;
                        height: 58px;
                    }

                    &>div {
                        font-size: .36rem;
                        margin-top: -.2rem;
                    }
                }
            }
        }
    }

    .content {
        background:
            radial-gradient(circle at top center, rgba(255, 210, 74, .18) 0%, rgba(255, 210, 74, 0) 44%),
            linear-gradient(180deg, rgba(106, 49, 8, .99) 0%, rgba(43, 15, 1, 1) 100%);
        border: .02rem solid rgba(255, 198, 83, .3);
        box-shadow: 0 .18rem .42rem rgba(25, 7, 0, .42);
        border-radius: .24rem;
        width: 94%;
        max-width: 600px;
        min-height: 300px;
        max-height: 80vh;
        box-sizing: border-box;
        position: relative;
        overflow: auto;
        display: flex;
        flex-direction: column;

        .header {
            height: .98rem;
            padding: .16rem 0 0 .38rem;
            position: relative;

            &>div:first-child {
                flex: 1;
                text-align: center;
                font-size: .44rem;
                font-weight: bold;
                color: #fff;
            }

            &>div:nth-child(2) {
                flex: 1;
                text-align: center;
                font-size: .28rem;
                color: $font-label-color;
            }

            .close {
                color: rgba(255, 238, 199, .84);
                font-size: .58rem;
                font-weight: 100;
                height: 1rem;
                width: 1rem;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                position: absolute;
                top: .08rem;
                right: .08rem;
                .iconfont{
                    font-size: .38rem;
                }
            }
        }

        .main_content {
            overflow: auto;
            padding: .24rem .34rem .36rem;
            margin: .24rem .3rem .3rem;
            margin-top: 0;
            border-radius: .24rem;

            .desc_txt {
                margin-top: .3rem;
                color: #fff;
                font-size: .32rem;
                line-height: .46rem;
                text-align: center;

                .plain {
                    font-weight: bold;
                }

                .highlight {
                    color: #e5ff00;
                    font-weight: bold;
                }
            }

            .reward_compare {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: .38rem 0 .58rem;
            }

            .super_card {
                width: 240px;
                background: linear-gradient(180deg, #42331d, #b05100);
                box-shadow: inset 0 0 17px rgba(255, 205, 0, .4);
                border-radius: 15px;
                border: 1px solid #FFAC26;
                position: relative;
                animation-name: customDropBounce;
                -webkit-transform-origin: center bottom;
                transform-origin: center bottom;
                animation-fill-mode: both;
                // padding: .2rem;

                @keyframes customDropBounce {

                    0%,
                    20%,
                    53%,
                    to {
                        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
                        animation-timing-function: cubic-bezier(.215, .61, .355, 1);
                        -webkit-transform: translate3d(0, 0, 0);
                        transform: translateZ(0)
                    }

                    40%,
                    43% {
                        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
                        animation-timing-function: cubic-bezier(.755, .05, .855, .06);
                        -webkit-transform: translate3d(0, -10px, 0) scaleY(1.05);
                        transform: translate3d(0, -10px, 0) scaleY(1.05)
                    }

                    70% {
                        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
                        animation-timing-function: cubic-bezier(.755, .05, .855, .06);
                        -webkit-transform: translate3d(0, -5px, 0) scaleY(1.03);
                        transform: translate3d(0, -5px, 0) scaleY(1.03)
                    }

                    80% {
                        -webkit-transition-timing-function: cubic-bezier(.215, .61, .355, 1);
                        transition-timing-function: cubic-bezier(.215, .61, .355, 1);
                        -webkit-transform: translate3d(0, 0, 0) scaleY(.95);
                        transform: translateZ(0) scaleY(.95)
                    }

                    90% {
                        -webkit-transform: translate3d(0, -4px, 0) scaleY(1.02);
                        transform: translate3d(0, -4px, 0) scaleY(1.02)
                    }
                }

                &>div {
                    position: relative;
                    z-index: 2;
                    padding: .28rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    .card_label {
                        font-size: .34rem;
                        color: #fff;
                        line-height: .34rem;
                        font-weight: bold;
                    }
                }

                &>img {
                    width: 100%;
                    height: 100%;
                    vertical-align: middle;
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    z-index: 1;
                }

                .coin {
                    width: 128px;
                    height: 128px;
                    vertical-align: middle;
                    margin-top: .2rem;
                }

                .super_amount {
                    margin-top: .18rem;
                    font-size: .5rem;
                    line-height: .58rem;
                    font-weight: bold;
                    color: #ffc90d;
                }
            }

            .normal_card {
                border-radius: 15px;
                text-align: center;
                padding: 16px;
                width: 170px;
                background: $bg-box-color;
                border: 1px solid $border-color;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                .card_label {
                    font-size: .26rem;
                    color: #fff;
                    line-height: .34rem;
                }

                .coin {
                    width: 88px;
                    height: 88px;
                    vertical-align: middle;
                    margin: .1rem 0;
                }

                .normal_amount {
                    color: #fff;
                    font-size: .36rem;
                    line-height: .44rem;
                    font-weight: bold;
                }
            }

            .claim-center {
                margin-left: .38rem;
                margin-right: .2rem;
                width: 70px;
                position: relative;
            }

            .multiple_mark {
                position: absolute;
                top: 0;
                left: 45%;
                width: 100%;
                animation: doubleArrowToLeft-24a7b3f5 1.3s ease-in-out infinite;

                &>img {
                    width: 70px;
                    height: 70px;
                }

                &>div {
                    font-size: .48rem;
                    color: #feeb76;
                    font-weight: 700;
                    text-align: center;
                    margin-top: -.38rem;
                }

                @keyframes doubleArrowToLeft-24a7b3f5 {

                    0%,
                    to {
                        transform: translate(-55%, -50%)
                    }

                    50% {
                        transform: translate(-45%, -50%)
                    }
                }
            }

            .btn_group {
                margin-top: .34rem;
                display: flex;
                flex-direction: column;
                gap: .16rem;

                &>div {
                    height: .72rem;
                    border-radius: .16rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: .28rem;
                    cursor: pointer;

                    &.primary {
                        background: $bg-btn-color;
                        color: $font-btn-color;
                    }

                    &.secondary {
                        background: rgba(255, 255, 255, .1);
                        color: #fff;
                    }
                }
            }
        }
    }
}</style>
